import React, {useRef, useState} from "react"

// @ts-ignore
import EstimatePickerPopover from "../../../../../../core/gd-ui/select-estimate/popover/ui5/popover-ui5"

interface Props {
    value       : number | null     // in hours
    onChange    : (hours: number | null) => void
    placeholder?: string
}

export default function FieldEstimate_ConditionInput({value, onChange, placeholder = 'Not set'}: Props) {

    const [open, setOpen]   = useState(false)
    const triggerRef        = useRef<HTMLDivElement>(null)

    const totalMinutes  = value != null ? Math.round(value * 60) : 0
    const {hours, minutes} = gd.utils.minutesToHM(totalMinutes)
    const displayValue  = value != null ? gd.utils.minutesHumanize(totalMinutes) : null

    const onSave = (pickerMinutes: number) => {
        onChange(pickerMinutes / 60)
        setOpen(false)
    }

    return (
        <div ref={triggerRef}
             className="ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10 cursor-pointer flex-row-left-center"
             style={{minWidth: 120}}
             onClick={() => setOpen(true)}>

            {displayValue
                ? <span>{displayValue}</span>
                : <span className="ui5-txt-not-important">{placeholder}</span>
            }

            {open &&
                <EstimatePickerPopover hours          = {hours}
                                       minutes        = {minutes}
                                       attachment     = "top center"
                                       targetAttachment = "bottom center"
                                       getTargetFunc  = {() => triggerRef.current}
                                       onClickOutside = {() => setOpen(false)}
                                       onSave         = {onSave}
                                       saveLabel      = "Apply"/>
            }
        </div>
    )
}
